import type { NavConfig } from '@pressreader/navigation-types';

export interface NavConfigWithArticlePopupId extends NavConfig {
    popupArticleId: string;
}

export function isNavConfigWithArticlePopupId(config: NavConfig): config is NavConfigWithArticlePopupId {
    return !!(config as NavConfigWithArticlePopupId).popupArticleId;
}
